<template>
  <b-form class="">
    <b-row v-if="props.mode == 'List'">
      <b-col cols="12" md="6">
        <b-form-group label="ชุดอนุกรรมการ" label-for="groupSelect">
          <vue-select
            label="name"
            value="id"
            v-model="groupSelect"
            :options="groupOptions"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as mediateDirectorGroupStore from "@/store/api/mediate-director/group.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    // const options = [
    //   { text: 'ทั้งหมด', value: null },
    //   { text: 'ใช้งาน', value: true },
    //   { text: 'ไม่ใช้งาน', value: false },
    // ]
    const options = [
      { label: "ทั้งหมด", code: null },
      { label: "ใช้งาน", code: true },
      { label: "ไม่ใช้งาน", code: false },
    ];

    const searchList = [
      {
        id: "directorGroupId",
        label: "ชุดอนุกรรมการ",
        value: "",
        class: "",
        style: "",
        placeholder: "คำค้นหา",
        type: "select",
        options: [],
      },
    ];

    return {
      options,
      search: searchList,
      props,
    };
  },
  data() {
    return {
      groupOptions: [],
      groupSelect: {
        id: null,
        name: "กรุณาเลือกข้อมูล",
      },
    };
  },
  mounted() {
    this.getDirectorGroup();
  },
  methods: {
    setDirectorGroupId(groupId) {
      const groupFind = this.groupOptions.find(
        (group) => group.id === groupId
      );
      if (groupFind) {
        this.groupSelect = groupFind;
        this.onSearchBtnClicked();
      } else {
        this.groupSelect = { id: null, name: "กรุณาเลือกข้อมูล" };
      }
    },
    onResetBtnClicked() {
      this.search[0].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        groupId: this.groupSelect?.id,
      };

      //console.log('onSearchBtnClicked', params)

      this.$emit("handleSubmit", params);
    },
    getDirectorGroup() {
      const _this = this;
      mediateDirectorGroupStore.search({ isActive: true }).then((response) => {
        //console.log("getDirectorGroup response =>", response.data.data);
        _this.groupOptions = response.data.data;
      });
    },
    selectOnInput() {
      this.$forceUpdate();
      console.log("selectOnInput", this.groupSelect);
      /// ปรับให้ตอน select submit ข้อมูลเลย
      this.onSearchBtnClicked();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
